import { useSession } from './use-session'

export function useMember() {
  const { data: session } = useSession()
  return session?.user?.member
}
